import { NotifyHelper } from "../../../helpers/toast";
import { eChuanDauRaChungChiActionsObj } from "../../action-types/chuong-trinh-dao-tao/IChuanDauRaChungChiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const chuanDauRaChungChiActions = {
    ...generateActions(eChuanDauRaChungChiActionsObj, "CHUAN_DAU_RA_CHUNG_CHI"),
    ...generateActionForKey(eChuanDauRaChungChiActionsObj, "CHUAN_DAU_RA_CHUNG_CHI", "SYS_SUCCESS", (m) => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eChuanDauRaChungChiActionsObj, "CHUAN_DAU_RA_CHUNG_CHI", "SYS_ERROR", (m) => { NotifyHelper.Error(m) }),
}